export const FileTypes = {
  FILE: 'file',
  FOLDER: 'folder',
}
